import { render, staticRenderFns } from "./UrlEditorScreenshotGallery.vue?vue&type=template&id=77c18f8e&"
import script from "./UrlEditorScreenshotGallery.vue?vue&type=script&lang=js&"
export * from "./UrlEditorScreenshotGallery.vue?vue&type=script&lang=js&"
import style0 from "./UrlEditorScreenshotGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports